import { IResponseError } from '../@types/fetch';

const HTML_MAPPINGS: { [key: string]: string } = {
    '&nbsp;': ' ',
    '&mdash;': '—',
    '&ndash;': '–',
    '&laquo;': '«',
    '&raquo;': '»'
};

const RE_HTML_ENTITIES = /&(?:nbsp|mdash|ndash|laquo|raquo);/g;
const RE_HAS_HTML_ENTITY = RegExp(RE_HTML_ENTITIES.source);

/**
 * Заменяет html мнемоники на символы юникода
 * @param {String} string
 * @returns {String}
 */
export function replaceHtmlEntities(string: string) {
    return (string && RE_HAS_HTML_ENTITY.test(string))
        ? string.replace(RE_HTML_ENTITIES, entity => HTML_MAPPINGS[entity])
        : string;
}

export function splitIntoTwoArrays<T>(arr: T[]): [T[], T[]] {
    const half = Math.ceil(arr.length / 2);

    return [
        arr.slice(0, half),
        arr.slice(half)
    ];
}

export function getErrorCode(err: IResponseError[] | IResponseError, internal = false) {
    const path = Array.isArray(err) ? '0.internalCode' : 'internalCode';
    const internalCode = getProp(err, path, '500');

    return internal ? String(internalCode) : Number(internalCode.slice(0, 3));
}

// tslint:disable:no-any
export function getProp(
    object: any,
    path: string | Array<string | number>,
    defaultValue?: any
): any {
    if (object === undefined || object === null) {
        return defaultValue;
    }

    const _path = Array.isArray(path)
        ? path
        : path.split('.').filter((part: any) => part.length);

    if (!_path.length) {
        return object;
    }

    const key = _path.shift() as string;

    return getProp(object[key], _path, defaultValue);
}

export function isElementVisible(el: Element) {
    const rect = el.getBoundingClientRect();
    const { top, bottom } = rect;

    return top >= 0 && bottom <= window.innerHeight;
}
